module.exports = __webpack_public_path__ + "img/fwlogo.64c01dab.svg";